import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getRootPageData } from './api/getRootPageData';
import type { StarterDashboardV2PageDataErrorCode } from './types';

export const {
	Context: StarterDashboardV2PageDataContext,
	Provider: StarterDashboardV2PageDataContextProvider,
	useContext: useStarterDashboardV2PageData,
	useAsyncData: useStarterDashboardV2PageDataFromApi,
	prefetchAsyncData: prefetchStarterDashboardV2PageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'StarterDashboardV2PageDataContext',
	dataProperty: 'pageData',
	getData: getRootPageData,
	hookDeps: ({ slug, countryCode, locale }) => [slug, countryCode, locale],
	getUniqueId: ({ slug }) => slug,
	errorHandler: pageDataErrorHandler<StarterDashboardV2PageDataErrorCode>(),
});
